import { useEffect, useRef, useState } from "react";
import { useDebounce } from "../hooks/useDebounce";
import { Icon } from "../ui/icons";

export function SearchBox(props: {
	onSearch: (props: {
		qry: string,
		cancelled: boolean,
		setResults: (results: any) => void,
	}) => void,
}) {

	const [qry, setQry] = useDebounce(300, "");
	
	const [results, setResults] = useState<any>();

	const ref = useRef<any>();

	useEffect(() => {
		const e = {
			qry,
			cancelled: false,
			setResults,
		};

		props.onSearch(e);

		return () => {
			e.cancelled = true;
		}
	}, [qry]);

	document.body.style.overflow = qry ? "hidden" : "auto";
	
	return (
		<div className={"search-box-container " + (qry ? "searching" : "")}>
			<div className="search-box relative">
				<Icon type="search" className="search-icon" />
				<Icon type="cross" className="close-button" onClick={() => {
					setQry("", true);
					if (ref.current) ref.current.value = "";
				}} />
				<input
					className="form-control"
					onChange={(e) => {
						setQry(e.target.value);
					}}
					ref={ref}
				/>
			</div>
			{results}
		</div>
		
	)
} 